import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import TextField from '@mui/material/TextField';

function MaskedTextField({ mask, alwaysShowMask = false, name, id, onChange, ...props }) {
  const [unmaskedValue, setUnmaskedValue] = useState('');
  const [maskedValue, setMaskedValue] = useState('');

  const handleChange = (event) => {
    const masked = event.target.value;
    const unmasked = masked.replace(/\D/g, '');
    setUnmaskedValue(unmasked);
    setMaskedValue(masked);
    
    if (onChange) {
      onChange({
        ...event,
        target: {
          ...event.target,
          value: unmasked,
        },
      });
    }
  };

  return (
    <>
      {/* Hidden input field with the unmasked value */}
      <input
        type="hidden"
        name={name}
        value={unmaskedValue}
        {...(id ? { id } : {})} // Conditionally add the id attribute
      />
      
      {/* Visible masked TextField */}
      <InputMask
        mask={mask}
        alwaysShowMask={alwaysShowMask}
        value={maskedValue}
        onChange={handleChange}
      >
        {(inputProps) => (
          <TextField
            {...inputProps}
            {...props}
            fullWidth
            name={`${name}-mask`}
            {...(id ? { id: `${id}-mask` } : {})} // Conditionally add the id attribute
          />
        )}
      </InputMask>
    </>
  );
}

export default MaskedTextField;